import QuestionnaireOption from "@/models/QuestionnaireOption";

export default class CompoundCourseRunStep {
    constructor(raw = {}) {
        this.id = raw.id;
        this.order = raw.order;
        this.verificationType = raw.verificationType;
        this.stepType = raw.stepType;
        this.storageId = raw.storageId;
        this.pdfs = raw.pdfs;
        this.pdfFile = raw.pdfFile;
        this.name = raw.name;
        this.questions = raw.questions ? raw.questions.map(question => new QuestionnaireOption(question)) : [];
        this.key = this.getKey();
    }

    getKey() {
        if (this.id !== null) {
            return this.id;
        } else {
            return (new Date()).getTime() + Math.floor(Math.random() * 10000).toString()
        }
    }

    empty() {
        this.name = "";
        this.order = 1;
        this.verificationType = "AUTO"
        this.stepType = "STORAGE"
        this.questions = [];
    }

    get isVerificationTypeAuto() {
        return this.verificationType === "AUTO";
    }

    get isVerificationTypeFromStorage() {
        return this.verificationType === "FROM_STORAGE";
    }

    get isVerificationTypeMANUAL() {
        return this.verificationType === "MANUAL";
    }

    get isStepTypeStorage() {
        return this.stepType === "STORAGE";
    }

    get isStepTypeQuestions() {
        return this.stepType === "QUESTIONS";
    }

    get isStepTypeShippersDeclaration() {
        return this.stepType === "SHIPPERS_DECLARATION";
    }

    get isStepTypeDeclaredGoods() {
        return this.stepType === "DECLARED_GOODS";
    }

}
